import { repo } from 'index';
import { useQuery } from '@tanstack/react-query';

const DEFAULT_PER_PAGE = 10;

export const useLicensePlates = ({ perPage = DEFAULT_PER_PAGE, page = 1, plateNumberCont } = {}) => {
  const { data, status, isLoading, refetch } = useQuery({
    queryKey: ['license-plates', page, perPage, plateNumberCont],
    queryFn: () =>
      repo.fetchLicensePlatesV2({
        page,
        perPage,
        plateNumberCont,
      }),
    refetchInterval: false,
  });

  const licensePlates = data?.data?.data ?? [];
  const licensePlatesPaging = data?.data?.paging ?? null;

  return {
    licensePlates,
    licensePlatesPaging,
    getLicensePlatesStatus: status,
    isGetLicensePlatesLoading: isLoading,
    refetchLicensePlates: refetch,
  };
};
